export const MAX_LOGS = 200

export const palette = {
  action: 'orange',
  actionSec: 'steelblue',
  info: 'cyan',
  title: 'black',
  titleSec: 'steelblue',
  heavyBackground: 'yellow',
  lightBackground: 'lightyellow',
  standardBackground: 'white',
  error: 'red',
  warning: 'orange',
  success: 'steelblue',
  busy: 'lightgreen',
}

export const paletteDark = {
  action: 'darkorange',
  actionSec: 'steelblue',
  info: 'cyan',
  title: 'white',
  titleSec: 'steelblue',
  heavyBackground: 'darkgreen',
  lightBackground: 'mediumseagreen',
  standardBackground: 'black',
  error: 'red',
  warning: 'orange',
  success: 'darkblue',
  busy: 'lightgreen',
}

// Colors assigned to a walk. Used for badges (next to the walk) and icons in the Calendar
// Note: the colors accepted by a badge must be standard or listed in the customTheme
export const walkColors = (isDark: boolean) => {
  const currentPalette = isDark ? paletteDark : palette
  return {
    // For badges
    leader: currentPalette.info,
    leaderStarted: currentPalette.info,
    openRegistered: currentPalette.warning,
    started: currentPalette.info,
    cancelled: currentPalette.warning,

    // For calendar
    calendarStarted: 'red',
    ended: 'transparent',
    dayWalk: isDark ? 'mediumseagreen' : 'green',

    // For both
    draft: 'gray',
    expected: isDark ? 'green' : 'mediumseagreen',
    multiday: 'yellow',
    campWalk: 'yellow',
    social: 'pink',
    other: 'tan',
    full: 'pink',
  }
}

export const constants = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT || '',
  WEBSITE_URL: 'https://www.bushwalkers.com',
  MEDICAL_FORM_URL: '/assets/LBBWEmergencyMedicalForm.pdf',
  NEW_MEMBERS_GUIDE_URL:
    'https://drive.google.com/file/d/1hbizhHgfMOvUBYsuhNhkDqzbGNvR0OBr/view',
  MODEL_RULES_URL:
    'https://drive.google.com/file/d/1fC7HJo1wm60u4JT0tQQpe_YaFFCNwR8C/view',
  MESSAGES_DELETE_DAYS: 14,
  MESSAGES_WALKS_DELETE_DAYS: 14,
  MEMBERSHIP_FULL_YEAR: 40,
  MEMBERSHIP_HALF_YEAR: 30,
}
